/**
 * SPDX-License-Identifier: MPL-2.0
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import MsgList from 'MsgList/MsgList';
import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import { NavMenu } from './NavMenu';

export class Layout extends Component {
  static displayName = Layout.name;

  render() {
    return (
      <div>
        <NavMenu />
        <MsgList />
        <Container>{this.props.children}</Container>
      </div>
    );
  }
}
